import React from 'react';
import Home from '../components/pages/Home';

const HomePage = (props) => {
    
    return <Home />;
};

export default HomePage;